export enum DrawIntervalTypes
{
  Weekly = 1,
  Biweekly = 2,
}
